import analytics from 'yoda-core-components/lib/helpers/Analytics/Analytics';
import analyticsActionTypes from '../actionTypes/AnalyticsActionTypes';
import {
    TRACK_OPEN_COUPON_DRAWER_EVENT,
    TRACK_PRINT_BAR_CODE_EVENT,
    TRACK_COUPON_SEE_DETAIL_EVENT,
} from '../actionTypes/CouponListActionTypes';
import CouponActionFilter from '../analytics/CouponActionFilter';

const CouponMiddleware = store => next => action => { // eslint-disable-line

    if (!__SERVER__) {
        let digitalData = null;
        let analyticsEventName = null;
        switch (action.type) {
            case analyticsActionTypes.UPDATE_ANALYTICS_CLICK_EVENT:
                analyticsEventName = 'couponApplied';
                digitalData = CouponActionFilter.getCouponDL(store, analyticsEventName);
                break;
            case analyticsActionTypes.REMOVE_ANALYTICS_CLICK_EVENT:
                analyticsEventName = 'couponRemoved';
                digitalData = CouponActionFilter.getCouponDL(store, analyticsEventName);
                break;
            case TRACK_OPEN_COUPON_DRAWER_EVENT:
                digitalData = {};
                analyticsEventName = 'openCouponDrawer';
                break;
            case TRACK_PRINT_BAR_CODE_EVENT:
                digitalData = {};
                analyticsEventName = 'printBarCode';
                break;
            case TRACK_COUPON_SEE_DETAIL_EVENT:
                digitalData = {};
                analyticsEventName = 'seeDetails';
                break;
            default:
                break;
        }
        /* istanbul ignore else */
        if (digitalData) {
            analytics.track(analyticsEventName, digitalData);
        }
    }
    return next(action);
};

export default CouponMiddleware;
